import { useMemo } from "react";
import { useGetExistingAccountPaymentPrefsQuery } from "../../../../graphql/supergraph.index";

export const usePaymentPrefEditForAccountWorkflowController = ({
  accountId,
  sourcePaymentPrefId,
}: {
  accountId: string;
  sourcePaymentPrefId?: string;
}) => {
  /**
   * Fetch the existing payment prefs on account
   * Used to display the available payment prefs,
   * after filtering by supported payments.
   */
  const {
    data: existingAccountPaymentPrefsData,
    loading: existingAccountPaymentPrefsLoading,
    error: existingAccountPaymentPrefsError,
  } = useGetExistingAccountPaymentPrefsQuery({
    variables: {
      accountId,
    },
  });

  const existingPaymentPref = useMemo(
    () =>
      existingAccountPaymentPrefsData?.account?.paymentPrefs?.find(
        (paymentPref) => paymentPref.id === sourcePaymentPrefId,
      ),
    [existingAccountPaymentPrefsData?.account?.paymentPrefs, sourcePaymentPrefId],
  );

  return {
    /**
     * Combining all the loading states into one
     */
    dataLoading: existingAccountPaymentPrefsLoading,

    /**
     * Combining all the error states into one
     */
    dataError: existingAccountPaymentPrefsError,

    /**
     * Payment pref to edit
     */
    existingPaymentPref,

    /**
     * Required only on GP flows and
     * has_position_payment_pref_staff_approvals arena FF is enabled
     */
    accountName: existingAccountPaymentPrefsData?.account?.name,
  };
};
